import { connect } from 'react-redux';
import RedirectRoute from './RedirectRoute';

const RedirectRouteContainer = (props) => <RedirectRoute {...props} />;

const mapStateTOProps = (state) => ({
  userAuth: state.login.userAuth,
});

export default connect(mapStateTOProps, null)(RedirectRouteContainer);
